import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const SentryHealthView = lazy(() => import('./SentryHealthView'));

const route: FuseRouteItemType = {
	path: 'health/sentry',
	element: <SentryHealthView />
};

export default route;
